import React from 'react'
import { Col, Row } from 'reactstrap'
import { FormRow, PropertyRenderer } from '@/components/changeRequests'
import context from '@/context'
import { bankNationality } from '@/enums/BankNationality'
import { InfoContent, InfoLabel, InfoRow } from '@/components/InfoRow'
import Resx from '@/components/Resx'
import { FieldSet } from './helpers/fieldSet'
import { useCoupledProps } from '@/components/changeRequests/useCoupledProps'
import { PermissionSectionProvider } from '@/components/changeRequests/institutionPermissionProvider'
import { institutionPermissionTypes } from '@/enums/institutionPermissionTypes'
import { usePropertyReader } from '@/hooks/usePropertyReader'
import { isNullOrEmptyString } from '@progress/kendo-data-query/dist/npm/utils'

export const BankBasicDetails = React.memo(function BankBasicDetails () {
  const { onChange: onStatusChange, isChanged: statusChanged } = useCoupledProps('status', ['changeDate', 'approvalNumber'])
  const [approvalNumber] = usePropertyReader(['approvalNumber'], 'originalData')

  return (
    <Row>
      <Col lg='6'>
        <PermissionSectionProvider institutionPermission={institutionPermissionTypes.enum.BankStatus}>
          <FieldSet className='state-history'>
            <FormRow label='Common.Status' name='status' inputType='lookup' dataSource={context.cache.getBankStates} onChange={onStatusChange} clientSide isCodeList required />
            <FormRow label='Common.ChangeDate' name='changeDate' inputType='date' required readonly={!statusChanged} />
            <FormRow label='Common.ApprovalNumber' name='approvalNumber' required inputProps={{ maxLength: 32 }} readonly={!(statusChanged || isNullOrEmptyString(approvalNumber))} />
          </FieldSet>
        </PermissionSectionProvider>
        <PermissionSectionProvider institutionPermission={institutionPermissionTypes.enum.BankDetail}>
          {context.isInternalApp() && <FormRow label='Institutions.IcbsIds' inputType='checkbox' name='includeInCoreBankingReports' />}
          <FormRow label='Institutions.NumberOfEmployees' name='numberOfEmployees' inputType='number' inputProps={{ min: 0, integerOnly: true }} />
          <FormRow label='Institutions.SwiftCode' name='swiftCode' inputProps={{ maxLength: 100 }} />
          <FormRow label='Institutions.Nationality' name='bankNationality' inputType='enum' inputProps={bankNationality} required />
          <FormRow label='Institutions.FinalApprovalNumber' name='finalApprovalNumber' />
        </PermissionSectionProvider>
      </Col>
      <PermissionSectionProvider institutionPermission={institutionPermissionTypes.enum.BankDetail}>
        <Col lg='6'>
          <FormRow label='Institutions.Code' name='code' readonly />
          <FormRow label='Institutions.SequenceNumber' name='sequenceNumber' readonly />
          <FormRow label='Common.ArabicName' name='name' required inputProps={{ maxLength: 150 }} />
          <FormRow label='Common.LatinName' name='latinName' required inputProps={{ maxLength: 150 }} />
          <FormRow label='Common.Type' name='bankType' inputType='lookup' dataSource={context.cache.getBankTypes} clientSide isCodeList required />
          <FormRow label='Institutions.OwnershipType' name='ownershipType' inputType='lookup' dataSource={context.cache.getOwnershipTypes} clientSide isCodeList required />
          <FormRow label='Institutions.PropertyType' name='propertyType' inputType='lookup' dataSource={context.cache.getPropertyTypes} clientSide isCodeList required />
          <FormRow label='Institutions.BankFoundationDate' name='bankFoundationDate' inputType='date' />
        </Col>
        <Col>
          <InfoRow form>
            <InfoLabel><Resx name='Common.Description' /></InfoLabel>
            <InfoContent>
              <PropertyRenderer name='description' inputType='textarea' inputProps={{ rows: 10 }} />
            </InfoContent>
          </InfoRow>
        </Col>
      </PermissionSectionProvider>
    </Row>
  )
})



// WEBPACK FOOTER //
// ./src/components/demographics/bankBasicDetails.js